const LOAD_PERSONAL_INFO           = 'LOAD_PERSONAL_INFO'
const LOAD_PERSONAL_INFO_SUCCESS   = 'LOAD_PERSONAL_INFO_SUCCESS'
const LOAD_PERSONAL_INFO_FAILED    = 'LOAD_PERSONAL_INFO_FAILED'
const UNMOUNT_PERSONAL_INFO        = 'UNMOUNT_PERSONAL_INFO'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const personalInfoReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_PERSONAL_INFO:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_PERSONAL_INFO_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_PERSONAL_INFO_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_PERSONAL_INFO:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default personalInfoReducer;